import Qr from 'qrcode.react';
export type QrcodeProps = {
  value: string;
};
export default function Qrcode({ value }: QrcodeProps) {
  return <Qr value={value} renderAs="canvas" />;
}